// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilteringOption.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Option Component
 */

import React, { PropTypes } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import ButtonCheck from 'share/components/controls/Izenda.ButtonCheck';

const propTypes = {
  onOptionClick: PropTypes.func,
  localization: PropTypes.object,
  hadSetting: PropTypes.bool,
  resetDefaultValue: PropTypes.func,
  enable: PropTypes.bool
};

const CrossFilteringOption = observer(({
  onOptionClick,
  localization,
  resetDefaultValue,
  hadSetting,
  enable
}) => {
  const buttonClasses = classnames('btn-icon icon-setting');
  return (
    <div className='izenda-CrossFiltering__CrossFilteringOption'>
      <span className='control-label u_alignMiddle'>
        {localization.getText('CROSSFILTERING_OPTION_LABEL')}
      </span>
      <div className='u_fullInlineBlock'>
        <ButtonCheck hasValue={hadSetting}
                     className={buttonClasses}
                     onClick={onOptionClick}
                     title={localization.getText('CROSSFILTERING_OPTION_TOOLTIP')}
                     disabled={!enable}/>
        {hadSetting && (<span>
          <i className="icon-cancel u-colorRed"
            title={localization.getText('PROPERTIES_EDITOR_REMOVE_SETTING')}
            onClick={resetDefaultValue} />
        </span>)}
      </div>
    </div>
  );
});

CrossFilteringOption.propTypes = propTypes;

export default CrossFilteringOption;



// WEBPACK FOOTER //
// ./ui/modules/CrossFiltering/Izenda.CrossFilteringOption.js